module.exports = __webpack_public_path__ + "c075c28f5106bc1195be69c83517c22b.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/00-Weser Kurier.png
// module id = 966
// module chunks = 0